<nts-numeric-text-box 
    [showErrorTooltip]="showErrorTooltip"
    [showErrorBorder]="showErrorBorder"
    [softDisable]="true" 
    [propertyViewModel]="propertyViewModel" 
    [tabIndex]="tabIndex"
    [updateOnBlur]="true"></nts-numeric-text-box>
